import * as React from 'react';
import { Row, Col } from 'reactstrap';
import Page from '../Page';
import AfrSummaryCore from '../AfrCore/AfrSummaryCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { UserRoleEnum } from '../../redux/UserSlice';



const AfrSummaryA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <Page>
                <AfrSummaryCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser} dataSection="Summary" />
            </Page>
        </React.Fragment>
    );
}

export default AfrSummaryA;